import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import UserSearchBar from "../components/user/UserSearchBar";
import Info from "../components/user/Info";
import HomeId from "../components/user/HomeId";
import { connect } from "react-redux";
import { getReportbyId, getAllDevice } from "../../../action/report";
import Alert from "../../layout/Alert";
import HomeSpaceDetails from "../components/devices/HomeSpaceDetails";
import Spinner from "../../layout/Spinner";
import { REPORT_ERROR } from "../../../action/types";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";

const UserInfoPage = ({ home, getReportbyId, getAllDevice, report }) => {
  const location = useLocation();
  const [showData, setShowData] = useState(false);
  const [loadHomeData, setLoadHomeData] = useState(false);
  const [primaryOrSecondaryUserHomeId, setPrimaryOrSecondaryUserHomeId] =
    useState("primaryUserHomeIds");
  const onSubmitSuccess = () => {
    setShowData(true);
    setLoadHomeData(true);
  };
  const onSubmitFailure = () => {
    setShowData(false);
    setLoadHomeData(false);
  };

  useEffect(() => {
    if (!showData && location.state) {
      setShowData(true);
    }
  }, []);

  useEffect(() => {
    if (loadHomeData === false || home.home === null || home.home.message) {
      return;
    } else {
      if (home.home[primaryOrSecondaryUserHomeId][0]) {
        getReportbyId(home.home[primaryOrSecondaryUserHomeId][0].homeId);
      } else {
        getReportbyId();
      }
      return;
    }
  }, [primaryOrSecondaryUserHomeId, loadHomeData, home.home]);

  useEffect(() => {
    if (report.report === null || !report.report.spaces) {
      return;
    } else {
      let searchText = "";
      report.report.spaces.map((element) => {
        element.devices.map((device) => {
          if (searchText.includes(device.deviceId)) {
            return;
          }
          searchText = searchText.concat(`${device.deviceId},`);
        });
      });
      getAllDevice(searchText);
      return;
    }
  }, [report.report]);
  /* Exact same structure as SearchDevice: content-wrapper > container > Grid > Grid item > search block */
  return (
    <ResponsiveContentWrapper>
      <div className="content-wrapper user-info-page">
        <div className="container">
          <Grid container spacing={2}>
            <Grid item xs={12} className="user-info-page-search-wrap">
              <UserSearchBar
                onSubmitSuccess={onSubmitSuccess}
                onSubmitFailure={onSubmitFailure}
              />
            </Grid>
          </Grid>
          <div className="mid-seprator" />
          <Alert />
          {showData && (
            <>
              <Box sx={{ mb: 3 }}>
                <Grid container spacing={2} sx={{ flexDirection: { xs: "column", md: "row" } }}>
                  <Grid item xs={12} md={8} sx={{ order: { xs: 2, md: 1 } }}>
                    <HomeId
                      onPrimaryOrSecondaryClick={setPrimaryOrSecondaryUserHomeId}
                      primaryOrSecondary={primaryOrSecondaryUserHomeId}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sx={{ order: { xs: 1, md: 2 } }}>
                    <Info />
                  </Grid>
                </Grid>
              </Box>
              {report.loading === true ? (
                <Box>
                  <Spinner />
                </Box>
              ) : (
                report.report && report.report.spaces && <HomeSpaceDetails />
              )}
            </>
          )}
        </div>
      </div>
    </ResponsiveContentWrapper>
  );
};

UserInfoPage.propTypes = {};

export default connect(
  (state) => ({
    home: state.home,
    report: state.report,
  }),
  { getReportbyId, getAllDevice }
)(UserInfoPage);
